<template>
  <div class="layout_body" id="layout_body">
    <!-- 生成base64图片用，兼容html2canvas生成图片跨域空白问题，勿删 -->
    <canvas ref="headCanvas" style="position: absolute; height: 0; width: 0; opacity: 0"></canvas>
    <div class="bg-wrapper" :style="getPageStyle">
      <!-- <img v-if="page.bgimage" :src="pageBackgroundImg" class="img-page-background" @error="onImgLoadError"> -->
    </div>
    <div class="layer-wrapper">
      <!-- 在渲染在module_config中配置的挂件，以免报错 -->
      <template v-for="(item, i) in widgets">
        <basic_module
          :key="item.tid"
          :module="item"
          :index="i"
          :type="type"
          v-if="!item.hidden && $store.state.widgets.PendantObj[item.cmpType]"
        />
      </template>
    </div>
  </div>
</template>

<script type="text/javascript">
import basic_module from '../basic_module'

export default {
  name: 'LayoutBodyIndex',
  data() {
    return {
      lastPlayAnimationPage: 0,
      backgroundImgLoadError: false,
      base64Img: ''
    }
  },
  props: {
    isCenter: {
      type: Boolean,
      default: false
    },
    module: {
      type: Object,
      default: null
    },
    widgets: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: 'edit'
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    animation_ini(ani) {
      let name = 'none'
      let duration = 0.1
      let delay = 0.5
      let count = 1
      if (ani.name) name = ani.name
      if (ani.duration) duration = ani.duration
      if (ani.delay) delay = ani.delay
      if (ani.count) count = ani.count
      // const str = `${name} ${duration}s ease ${delay}s ${count} both`;
      return {
        name,
        duration,
        delay,
        count
      }
    },
    hasOwn(obj, propName) {
      // 判断对象本身某个属性是否存在（继承过来的属性，自身没有定义也会返回false，如果继承的也算那就用 Reflect.has(obj, propName)）
      return Object.prototype.hasOwnProperty.call(obj, propName)
    },
    onImgLoadError() {
      this.backgroundImgLoadError = true
    },
    // 将网络图片转化为Base64
    ImageToBase64(url) {
      const vm = this
      // 一定要设置为let，不然图片不显示，下面解释↓
      const image = new Image()
      // 解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = url
      // image.onload为异步加载
      image.onload = () => {
        var canvas = vm.$refs.headCanvas
        var context = canvas.getContext('2d')
        canvas.width = image.width
        canvas.height = image.height
        context.drawImage(image, 0, 0, image.width, image.height)
        var dataurl = canvas.toDataURL('image/png')
        this.base64Img = dataurl
      }
    }
  },
  computed: {
    current_page_index() {
      return this.$store.state.body.current_page_index
    },
    pages() {
      return this.$store.state.body.data.pages
    },
    page() {
      let end = {}
      const now_page = this.pages
      if (now_page) end = now_page
      return end
    },
    getPageStyle() {
      var bgImg =  this.page.bgimage // 用于实时更新背景图
      if (bgImg && bgImg.indexOf('http') > -1) {
        this.ImageToBase64(bgImg)
        bgImg = this.base64Img
      }
      const style = {
        backgroundColor: this.page.selectBgType === '1' && this.$route.query.type != 'detail' ? this.page.bgcol : '',
        backgroundImage: this.page.selectBgType === '1' ? '' : `url("${bgImg}")`,
        backgroundPosition: `${this.page.bgpositionx}% 50%`,
        top: '0px',
        height: '100%'
      }
      if (this.page.long_page) {
        style.height = this.page.height + 'px'
        style.top = 0 + 'px'
      }
      return style
    },
    pageBackgroundImg() {
      return this.backgroundImgLoadError ? this.page.bgimage : this.utils.src_has_gif(this.page.bgimage)
    }
  },
  watch: {},
  created() {},
  mounted() {},
  components: {
    basic_module
  }
}
</script>

<style lang="scss" scoped>
.layout_body {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 50% 50%;
  background-origin: content-box;
}

.layer-wrapper {
  position: absolute;
  z-index: 1;
}

.img-page-background {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.layout_body_dashed {
  width: 100%;
  height: 0;
  //   border: 1px #999 dashed;
  position: absolute;
  left: 0;
  z-index: 99;
}
.entire_text {
  font-size: 14px;
  color: #333;
  right: -50px;
  position: absolute;
  line-height: 14px;
}
.layout_body_dashed_top {
  top: 0;
}
.layout_body_dashed_bottom {
  bottom: 0;
}
</style>
<style>
.layout_body {
  user-select: none;
}
</style>
